<div class="mat-dialog-container">
    <div style="font-family: poppinsB; font-size:25px;" [innerHTML]="'CHANGE_ROUTE.INSTRUCTION1' | translate"></div>
    <div style="font-family: poppinsR; margin-top: 10px;" [innerHTML]="'CHANGE_ROUTE.INSTRUCTION2' | translate"></div>
    <button style="width: 100%; margin-top: 35px;" mat-raised-button color="accent" (click)="closeDialog()" translate>{{ 'CHANGE_ROUTE.OK' | translate }}</button>
</div>